
import Diagram from "../../../assets/duotone/Diagram.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DiagramIcon({ className, dataTestid = "DiagramIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Diagram data-testid={dataTestid} className={classes} {...rest} />
  );
}
